import { useMemo } from "react";
import { useApiError } from "../ReactHookForm/ApiError/ApiError";
import { Box } from "../ui/box";
import { Alert } from "../ui/alert";
import { useIntl } from "react-intl";
import { List } from "@chakra-ui/react";
import { Stack } from "../ui/stack";

/**
 * @typedef {object} Props
 * @prop {boolean} [withCaughtErrors]
 */
/**
 * @param {Props & import("../ui/box").BoxProps} props
 */
export function ApiErrorMessage({ withCaughtErrors = false, ...otherProps }) {
  const intl = useIntl();

  const { message, caughtErrors, uncaughtErrors } = useApiError();

  const uncaughtErrorsList = useMemo(() => {
    return Object.values(uncaughtErrors);
  }, [uncaughtErrors]);

  const caughtErrorsList = useMemo(() => {
    return Object.values(caughtErrors);
  }, [caughtErrors]);

  if (
    message === null &&
    ((withCaughtErrors === true && caughtErrorsList.length === 0) ||
      withCaughtErrors === false) &&
    uncaughtErrorsList.length === 0
  ) {
    return null;
  }

  return (
    <Box pb="1rem" {...otherProps}>
      <Alert
        status="error"
        title={
          message ??
          intl.formatMessage({ defaultMessage: "Une erreur est survenue" })
        }
      >
        {(uncaughtErrorsList?.length > 0 ||
          (withCaughtErrors && caughtErrorsList?.length > 0)) && (
          <Stack>
            {uncaughtErrorsList?.length > 0 && (
              <List.Root display="block">
                {uncaughtErrorsList?.map?.((value, index) => (
                  <List.Item key={index}>{value}</List.Item>
                ))}
              </List.Root>
            )}

            {withCaughtErrors && caughtErrorsList?.length > 0 && (
              <List.Root display="block">
                {caughtErrorsList?.map?.((value, index) => (
                  <List.Item key={index}>{value}</List.Item>
                ))}
              </List.Root>
            )}
          </Stack>
        )}
      </Alert>
    </Box>
  );
}
